import { render, staticRenderFns } from "./ProjectContent.vue?vue&type=template&id=7aa7ed36&"
import script from "./ProjectContent.vue?vue&type=script&lang=ts&"
export * from "./ProjectContent.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports